export enum ContactType {
    Email = 'EMAIL',
    Phone = 'PHONE',
}
